import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { AppStateService } from '../../services/app-state.service';
import { WallpaperService } from '../../services/wallpaper.service';
import { BaseAPIService } from 'src/app/services/base-api.service';

@Component({
    selector: 'app-art-search',
    templateUrl: './art-search.component.html'
})
export class ArtSearchComponent implements OnInit, OnDestroy {

    products: any[] = [];
    isLoading = true;
    loadError = false;
    totalRecords = 0;

    showFilterDrawer = false;
    showSortDropdown = false;

    // ROUTE
    sub_cat_slug = '';
    category = '';
    activeThemeName = '';

    // FILTER DATA
    collections: any[] = [];
    artTypes: any[] = [];
    spaces: any[] = [];
    sizes: any[] = [];
    orientations: any[] = [];
    productTypes: any[] = [];

    facet: any = {};

    // SELECTED
    selectedCollections: any[] = [];
    selectedArtTypes: any[] = [];
    selectedSpaces: any[] = [];
    selectedSizes: any[] = [];
    selectedOrientations: any[] = [];
    selectedProductTypes: any[] = [];

    currentPage = 1;
    readonly pageSize = 36;

    // SORT
    sortBy = 'Newest';
    sortOptions = [
        'Relevance',
        'Popular',
        'Newest',
        'Price: Low → High',
        'Price: High → Low'
    ];
    sortby = 'created_at';
    sortDir = 'desc';

    // UI
    openSections: Record<string, boolean> = {
        image_subcategory_id: true,
        artType: false,
        orientation: false
    };

    wishlistIds = new Set<string>();
    private sub = new Subscription();

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        public state: AppStateService,
        private cdr: ChangeDetectorRef,
        private wallpaperService: WallpaperService,
        private baseApiService: BaseAPIService
    ) { }

    // ─────────────────────────────

    ngOnInit() {

        // ROUTE PARAMS
        this.route.params.subscribe(params => {
            this.sub_cat_slug = params['name'] || '';
            this.category = params['category'] || '';
            this.activeThemeName = this.sub_cat_slug
                ? this.sub_cat_slug.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
                : '';
            this.selectedSubCategories = []; // reset drawer selections on route change
        });

        // QUERY PARAMS
        this.route.queryParams.subscribe(params => {
            this.currentPage = params['page'] ? +params['page'] : 1;

            this.selectedProductTypes = params['product_type'] ? params['product_type'].split(',') : [];
            this.selectedArtTypes = params['art_type'] ? params['art_type'].split(',') : [];
            this.selectedOrientations = params['orientation'] ? params['orientation'].split(',') : [];
        });

        // STATIC DATA
        this.productTypes = [
            { name: 'Art Prints', slug: 'art_print' },
            { name: 'Canvas Art', slug: 'canvas' },
            { name: 'Framed Art', slug: 'framing' }
        ];

        this.artTypes = [
            { id: 1, name: 'Painting', activated: false },
            { id: 2, name: 'Photography', activated: false },
            { id: 4, name: 'Illustrations', activated: false },
            { id: 3, name: 'Posters', activated: false },
        ];

        this.loadFilters();
        this.loadProducts();
    }

    // ─────────────────────────────

    topCategories :any= [];


    public shapes = [
        { code: 'h', name: 'Horizontal', path: 'assets/images/product/shapes/horizontal.png', 'activated': false },
        { code: 'v', name: 'Vertical', path: 'assets/images/product/shapes/vertical.png', 'activated': false },
        { code: 'sq', name: 'Square', path: 'assets/images/product/shapes/square.png', 'activated': false },
        { code: 'p', name: 'Panoramic Horizontal', path: 'assets/images/product/shapes/panoramic-horizontal.png', 'activated': false },
        { code: 's', name: 'Panoramic Vertical', path: 'assets/images/product/shapes/panoramic-vertical.png', 'activated': false },
    ];

    loadFilters() {
        const orderBy = JSON.stringify([['name', 'asc']]);

        this.wallpaperService.getWallArtCategories('themes', '').subscribe(res => {
            this.topCategories = res;
            // Update active theme name from loaded data if we have a slug match
            if (this.sub_cat_slug) {
                const match = this.topCategories.find((c: any) => c.sub_cat_slug === this.sub_cat_slug || c.slug === this.sub_cat_slug);
                if (match) this.activeThemeName = match.title || match.name || this.activeThemeName;
            }
        });

    }

    removeThemeFilter() {
        this.sub_cat_slug = '';
        this.activeThemeName = '';
        this.currentPage = 1;
        this.loadProducts();
    }

    // ─────────────────────────────

    private updateUrl() {
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
                page: this.currentPage,
                product_type: this.selectedProductTypes.join(','),
                art_type: this.selectedArtTypes.join(','),
                orientation: this.selectedOrientations.join(',')
            },
            queryParamsHandling: 'merge'
        });
    }

    // ─────────────────────────────


    color_key = '';
    subject = '';
    contributor_code = '';
    // ─────────────────────────────

    loadProducts(skipLoader = false) {
        this.isLoading = true;

        const allSubCats = [...this.selectedSubCategories];
        if (this.sub_cat_slug && !allSubCats.includes(this.sub_cat_slug)) {
            allSubCats.push(this.sub_cat_slug);
        }
        const sub_cat_slug = allSubCats.join(',');

        const orientation = this.selectedOrientations.join(',');
        const art_type = this.selectedArtTypes.join(',');
        const cat_slug = this.category || '';
        const subcategory = this.selectedProductTypes.join(',');

        this.baseApiService.getWallartProducts(
            sub_cat_slug,
            this.color_key,
            orientation,
            art_type,
            this.subject,
            this.currentPage,
            this.pageSize,
            cat_slug,
            this.contributor_code,
            skipLoader,
            this.sortby,
            this.sortDir
        ).subscribe({
            next: (res: any) => {
                    console.log('API response', res);
                // 🔥 IMPORTANT (old response structure)
                this.products = res?.results || res?.data || [];
                this.totalRecords = res?.total || 0;
                if (this.products.length) {
                    console.log('🔥 art-search product sample keys:', Object.keys(this.products[0]));
                    console.log('🔥 art-search FIRST product full data:', JSON.stringify(this.products[0]));
                }

                this.facet = res?.facet_field || {};

                this.isLoading = false;
                this.cdr.detectChanges();
            },
            error: () => {
                this.loadError = true;
                this.isLoading = false;
            }
        });
    }

    // ─────────────────────────────
    // FILTER

    selectedSubCategories: any[] = [];

    toggleFilter(type: string, value: any, checked: boolean) {

        const map: any = {
            product_type: this.selectedProductTypes,
            art_type: this.selectedArtTypes,
            orientation: this.selectedOrientations,
            image_subcategory_id: this.selectedSubCategories
        };

        const arr = map[type];
        if (!arr) return;

        if (checked) {
            if (!arr.includes(value)) arr.push(value);
        } else {
            const i = arr.indexOf(value);
            if (i > -1) arr.splice(i, 1);
        }

        this.currentPage = 1;
        this.updateUrl();
        this.loadProducts();
    }

    clearAll() {
        this.selectedProductTypes = [];
        this.selectedArtTypes = [];
        this.selectedOrientations = [];
        this.selectedSubCategories = [];
        this.sub_cat_slug = '';
        this.activeThemeName = '';
        this.shapes.forEach(s => s.activated = false);
        this.artTypes.forEach(a => a.activated = false);

        this.currentPage = 1;

        this.updateUrl();
        this.loadProducts();
    }

    // ─────────────────────────────
    // UI

    toggleSection(key: string) {
        this.openSections[key] = !this.openSections[key];
    }

    onSortChange(opt: string) {
        this.sortBy = opt;

        switch (opt) {
            case 'Price: Low → High':
                this.sortby = 'net_price_tax';
                this.sortDir = 'asc';
                break;

            case 'Price: High → Low':
                this.sortby = 'net_price_tax';
                this.sortDir = 'desc';
                break;

            case 'Popular':
                this.sortby = 'popular_art';
                this.sortDir = 'desc';
                break;

            case 'Relevance':
                this.sortby = 'recommended';
                this.sortDir = 'desc';
                break;

            default:
                this.sortby = 'created_at';
                this.sortDir = 'desc';
        }

        this.currentPage = 1;
        this.updateUrl();
        this.loadProducts();
    }

    // ─────────────────────────────
    // PAGINATION

    get totalPages(): number {
        return Math.ceil(this.totalRecords / this.pageSize);
    }

    get pageNumbers(): number[] {
        const total = this.totalPages;
        if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
        const pages: number[] = [1];
        const cur = this.currentPage;
        const start = Math.max(2, cur - 1);
        const end = Math.min(total - 1, cur + 1);
        if (start > 2) pages.push(-1);
        for (let i = start; i <= end; i++) pages.push(i);
        if (end < total - 1) pages.push(-1);
        pages.push(total);
        return pages;
    }

    goToPage(p: number) {
        if (p < 1 || p > this.totalPages) return;

        this.currentPage = p;
        this.updateUrl();
        this.loadProducts();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // ─────────────────────────────
    // HELPERS

    isThemeSelected(item: any): boolean {
        return this.selectedSubCategories.includes(item.sub_cat_slug) || item.sub_cat_slug === this.sub_cat_slug;
    }

    toggleTheme(item: any) {
        const slug = item.sub_cat_slug;
        if (this.isThemeSelected(item)) {
            // Remove from route param if that's the source
            if (this.sub_cat_slug === slug) {
                this.sub_cat_slug = '';
                this.activeThemeName = '';
            }
            // Also remove from selectedSubCategories
            const i = this.selectedSubCategories.indexOf(slug);
            if (i > -1) this.selectedSubCategories.splice(i, 1);
        } else {
            if (!this.selectedSubCategories.includes(slug)) {
                this.selectedSubCategories.push(slug);
            }
        }
        this.currentPage = 1;
        this.updateUrl();
        this.loadProducts();
    }

    getFacetCount(type: string, key: any): number {
        return this.facet?.[type]?.[key] || 0;
    }

    getItemImage(item: any) {
        return "https://storage.googleapis.com/static-mahattaart-com/400x400/media/" + item?.image_filename;
    }

    getItemName(item: any) {
        return item?.image_caption || '';
    }

    getItemSize(item: any) {
        return item?.final_size || '';
    }

    getItemPrice(item: any) {
        return item?.net_price_tax || 0;
    }

    getItemMrp(item: any) {
        return item?.list_price_tax || 0;
    }

    getDiscountPercent(item: any) {
        return item?.discount || 0;
    }

    isPopular(item: any) {
        return item?.popular_art === 1;
    }

    navigateToPDP(item: any) {
        const imageId = item?.image_id || item?.id || '';
        this.router.navigate(['/product-customization'], {
            queryParams: {
                product: 'wall_art',
                product_type: 'canvas',
                image_id: imageId
            }
        });
    }

    // ─────────────────────────────
    // WISHLIST

    toggleWishlist(item: any, e: Event) {
        e.stopPropagation();
        console.log('wishlist toggle', item);
    }

    isWishlisted(id: string): boolean {
        return this.wishlistIds.has(id);
    }

    addToCart(item: any, e: Event) {
        e.stopPropagation();
        console.log('add to cart', item);
    }

    // ─────────────────────────────

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    applyFilters() {
        this.currentPage = 1;

        this.updateUrl();     // URL sync
        this.loadProducts();  // reload data

        this.showFilterDrawer = false; // drawer close (important UX)
    }
}